import React from 'react';
import { Card, CardBody } from 'reactstrap';
import { withRouter } from 'react-router-dom';
import ToolButton from '../../../common/ToolButton';
import BackButton from '../../../common/BackButton';

const UserTools = ({
  mode,
  history
}) => {
  return (
    <Card>
      <CardBody>
        <ToolButton
          color={"primary"}
          handleClick={() => history.push("/user/" + mode)}
          icon={"plus"}
          text={ mode === "admin"
              ? "Dodaj Administratora"
              : "Dodaj Magazyniera"
          }
        />
        <BackButton />
      </CardBody>
    </Card>
  )
}

export default withRouter(UserTools);
